const AGE_VARIATION_TYPE_ID = 0;

export interface AgeBucket {
  key: string;
  label: string;
  variationValues: string[];
}

export const AGE_BUCKETS: AgeBucket[] = [
  { key: '1-4', label: '1 a 4 anos', variationValues: ['1', '2', '4'] },
  { key: '6-8', label: '6 a 8 anos', variationValues: ['6', '8'] },
  { key: '10-12', label: '10 a 12 anos', variationValues: ['10', '12'] },
  { key: '14', label: '14 anos', variationValues: ['14'] },
];

export function getAgeBucketHref(bucket: AgeBucket): string {
  return `/catalogo?varType=${AGE_VARIATION_TYPE_ID}&var=${bucket.variationValues.join(',')}`;
}
